export enum EnHeaderStatus {
  DEFAULT_VIEW = 'default',
  CONTACT_SALES = 'contact-sales',
}
